import './sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Sentry } from './sentry'
import './index.css'
import App from './App.tsx'

function FallbackError() {
  return (
    <div style={{ padding: '4rem 2rem', textAlign: 'center', fontFamily: 'system-ui' }}>
      <h1>Algo deu errado.</h1>
      <p>Já fomos notificados. Tenta recarregar a página.</p>
    </div>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackError />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
